import React from 'react'

import useCategories from 'utils/hooks/queries/games/useCategories'

import useCategory from '../../hooks/useCategory'
import useSearch from '../../hooks/useSearch'
import IconAll from './components/IconAll'
import IconFavorite from './components/IconFavorite'
import IconHome from './components/IconHome'
import Providers from './components/Providers'

function Icons() {
  const { data: categories, isPending } = useCategories()
  const { search } = useSearch()
  const isSearchActive = search.length > 0
  const { category } = useCategory()

  if (isPending) {
    return null
  }

  return (
    <>
      <IconHome
        isSearching={isSearchActive}
        category={category}
      />
      <IconAll
        isSearching={isSearchActive}
        category={category}
        categories={categories}
      />
      <IconFavorite
        isSearching={isSearchActive}
        category={category}
      />
      <Providers />
    </>
  )
}

export default Icons
